import clsx from 'clsx'
import { Block } from 'utils/block'
import { Col } from 'components/ui/Col'
import { Row } from 'components/ui/Row'
import { formatISODate } from 'utils/dates'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'
import { mainApiService } from 'api/config'
import { useQueryClient } from '@tanstack/react-query'
import { BLOCKS_QUERY_KEY } from 'api/blocks'
import { showSuccessToast } from 'utils/toast'
import { Icon } from 'components/ui/Icon'
import { useModal } from 'providers/ModalProvider'
import { ConfirmModal } from 'components/modal/ConfirmModal'

type BlockCardProps = {
  block: Block
}

export const BlockCard = ({ block }: BlockCardProps) => {
  const queryClient = useQueryClient()
  const createdAt = formatISODate(block.createdAt, 'dd/MM/yyyy HH:mm')
  const updatedAt = formatISODate(block.updatedAt, 'dd/MM/yyyy HH:mm')
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { open } = useModal()

  const onClickCard = () => {
    navigate(`${location.pathname}/blocks/${block._id}`)
  }

  const handleDeleteNote = () => {
    open(
      <ConfirmModal
        title={t('notes.deleteNoteTitle')}
        description={t('notes.deleteNoteMessage')}
        onConfirm={async () => {
          await mainApiService.deleteItem('blocks', block._id)
          await queryClient.invalidateQueries({
            queryKey: [BLOCKS_QUERY_KEY],
          })
        }}
        onSuccess={() => showSuccessToast(t('notes.deleteNoteSuccess'))}
      />,
    )
  }

  return (
    <Col
      onClick={onClickCard}
      justifyContent={'flex-start'}
      alignItems={'flex-start'}
      className={clsx(
        'tw-cursor-pointer',
        'tw-w-full',
        'tw-mb-2 tw-p-2 tw-text-white tw-rounded-xl tw-transition-all tw-duration-500 tw-ease-in-out tw-text-sm',
        'tw-bg-secondary-500',
      )}
    >
      <Row justifyContent={'space-between'} width={'100%'} className={'tw-text-base tw-font-bold'}>
        {block.title}
        <div>
          <Icon
            icon={['fas', 'trash']}
            onClick={(e) => {
              e.stopPropagation()
              handleDeleteNote()
            }}
          />
        </div>
      </Row>
      <Row className={'tw-text-sm tw-font-light'}>
        {t('notes.createdAt')}
        {createdAt}
      </Row>
      <Row className={'tw-text-sm tw-font-light'}>
        {t('notes.updatedAt')}
        {updatedAt}
      </Row>
    </Col>
  )
}
